<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><span><span epub:type="pagebreak" id="page_vi" title="vi"><span epub:type="pagebreak" id="page_vii" title="vii">REPUBLIC</span></span></span></p>
<p class="halftitlea"><span>OF</span></p>
<p class="halftitlea"><span>OUTSIDERS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Front.vue?7875220a